import {
  GetInsuranceQuoteResponse,
  GetLatestQuoteGroupResponse,
} from '@nxcr-org/web-api-interface/lib/insurance_service_pb'
import {
  getInsuranceQuote,
  getLatestQuoteGroup,
} from 'global-apis/nexus-service-insurance'
import { useQuery } from '@tanstack/react-query'

const useInsuranceQuoteBlock = () => {
  function useInsuranceQuote({ subscriptionId, customerId }) {
    const { data: insuranceQuote } = useQuery({
      queryKey: ['/insuranceQuote'],
      queryFn: () =>
        getInsuranceQuote({ subscriptionId, customerId }).then(
          (res: GetInsuranceQuoteResponse.AsObject) => res
        ),
    }
    )

    return {
      insuranceQuote,
    }
  }
  function useLatestQuoteGroup({ subscriptionId }) {
    const { data: latestQuoteGroup } = useQuery({
      queryKey: ['/latestQuoteGroup'],
      queryFn: () =>
        getLatestQuoteGroup({ subscriptionId }).then(
          (res: GetLatestQuoteGroupResponse.AsObject) =>
            res.latestquoteresponseList
        ),
      placeholderData: [],
    }
    )
    return {
      latestQuoteGroup,
    }
  }
  return {
    useInsuranceQuote,
    useLatestQuoteGroup,
  }
}
export default useInsuranceQuoteBlock
